import styled from "styled-components";

export const MeetingAgendaWrapper = styled.div`
    width: 1000px;
    margin: 0 auto;
    .tabs {
        .ant-tabs-nav {
            border-bottom: 2px solid #8c8cb5;
            padding-left: 45px;
            .ant-tabs-nav-wrap {
                margin-bottom: -2px;
            }

            .ant-tabs-tab {
                padding: 5px 30px;
                font-size: 18px;
                margin-left: 10px;
                margin-right: 10px;
            }
            .ant-tabs-tab-active {
                border-top: 2px solid #8c8cb5;
                border-left: 2px solid #8c8cb5;
                border-right: 2px solid #8c8cb5;
                border-bottom: 3px solid white;
                .ant-tabs-tab-btn {
                    color: #764eb3;
                }
            }
            .ant-tabs-ink-bar {
                display: none;
            }
        }
    }
    @media screen and (max-width: 750px) {
        width: 100%;
        .tabs {
            .ant-tabs-nav {
                padding-left: 15px;
                .ant-tabs-tab {
                    padding: 3px 10px;
                    font-size: 16px;
                    margin: 0 5px;
                }
            }
        }
    }
`;

export const TextWrapper = styled.div`
    padding-top: 30px;
    h3 {
        background-color: #d4d4e3;
        font-size: 20px;
        padding-left: 15px;
        margin-bottom: 30px;
    }
    p {
        font-size: 16px;
        padding-left: 15px;
        line-height: 30px;
        span {
            display: inline-block;
            width: 2px;
            background-color: #272775;
            height: 16px;
            vertical-align: middle;
            margin-right: 10px;
        }
    }
    .mtb {
        margin: 15px 0;
    }
    @media screen and (max-width: 750px) {
        padding-top: 5px;
        h3 {
            margin-bottom: 15px;
        }
        p {
            font-size: 14px;
            padding-right: 10px;
            text-align: justify;
        }
        .mtb {
            margin: 5px 0;
        }
    }
`;
